<template>
<div>
  <div id="app1">
    <div class="container1 pt-5">
    <div class="row mt-5">
      <div class="col-sm-2 col-md-2 col-lg-2">
          <div class="sample5"></div>
          <button class="btn-explain1" @click="openModal">
            <p class="explain_moji1">あそびかた</p>
          </button>
          <Modal ref="modal" id="modal_explain">
          <div class="modal_div">
          <img src=".././assets/modal_explain.png" class="img_modal" width="500" height="703">
          </div>
          <br/>
          </Modal>
        </div>
      <div class="col-sm-7 col-md-7 col-lg-5  board_group board_group1">
        <main class="flexbox flexbox1">
          <Board id="board-0" :srcImg="board0.src"></Board>
          <Board id="board-1" :srcImg="board1.src"> </Board>
          <Board id="board-2" :srcImg="board2.src"> </Board>
          <Board id="board-3" :srcImg="board3.src"> </Board>
          <Board id="board-4" :srcImg="board4.src"> </Board>
          <Board id="board-5" :srcImg="board5.src"> </Board>
          <Board id="board-6" :srcImg="board6.src"> </Board>
          <Board id="board-7" :srcImg="board7.src"> </Board>
          <Board id="board-8" :srcImg="board8.src"> </Board>
        </main>
        <router-link to="home">
           <button class="back_button1">戻る</button>
        </router-link>

      </div>
      <div class="place_for_piece1 col-md-2 col-lg-2">
        <!-- <Card id="card-1" draggable="true" :style="card1">
          <p>Card one</p>
        </Card> -->
        <Card id="card-1" draggable="true" :style="card_result_1">
          <p class="card_moji1">Card one</p>
          <button @click="play_sound(1)" :style="style1" class="sound_btn4"></button>
        </Card>
        <Card id="card-2" draggable="true" :style="card_result_2">
          <p class="card_moji1">Card two</p>
          <button @click="play_sound(2)" :style="style1" class="sound_btn4"></button>
        </Card>
        <Card id="card-3" draggable="true" :style="card_result_3">
          <p class="card_moji1">Card three</p>
          <button @click="play_sound(3)" :style="style1" class="sound_btn4"></button>
        </Card>
        <Card id="card-4" draggable="true" :style="card_result_4">
          <p class="card_moji1">Card four</p>
          <button @click="play_sound(4)" :style="style1" class="sound_btn4"></button>
        </Card>
        <Card id="card-5" draggable="true" :style="card_result_5">
            <p class="card_moji1">Card five</p>
            <button @click="play_sound(5)" :style="style1" class="sound_btn4"></button>
        </Card>
        <Card id="card-6" draggable="true" :style="card_result_6">
            <p class="card_moji1">Card six</p>
            <button @click="play_sound(5)" :style="style1" class="sound_btn4"></button>
        </Card>
        <Card id="card-7" draggable="true" :style="card_result_7">
            <p class="card_moji1">Card seven</p>
            <button @click="play_sound(5)" :style="style1" class="sound_btn4"></button>
        </Card>
        <Card id="card-8" draggable="true" :style="card_result_8">
            <p class="card_moji1">Card eight</p>
            <button @click="play_sound(5)" :style="style1" class="sound_btn4"></button>
        </Card>
        <Card id="card-9" draggable="true" :style="card_result_9">
            <p class="card_moji1">Card nine</p>
            <button @click="play_sound(5)" :style="style1" class="sound_btn4"></button>
        </Card>
      </div>
    </div>
    </div>
    <div class="bg-blue">{{last_result}}</div>
    <Modal ref="modal" id="modal_done">
      <div class="modal_div">
        <p id="comment">おめでとう！
        パズルが完成したよ！</p>
        <img src=".././assets/puzzle/puzzle5/puzzle5.jpg" class="img_modal" width="400" height="400">
        <br/><br/>
        完成したパズルは、
        <router-link to="gallery">
        ギャラリー一覧
        </router-link>
        から見れるよ！
        <br/>今回聞こえたすべての音が流れてるのがわかるかな？？
      </div>
      <br/>
    </Modal>
  </div>
</div>
</template>

<script>


import Board from "./Board_5";
import Card from "./Card_5";
import Modal from "./Modal";

export default {
  name: "game_1",
  //ここに今回使用するcomponentsを記載
  //ここに今回使用するcomponentsを記載
  components: {
    //added
    //added
    Board,
    Card,
    Modal,
  },

  mounted() {
    //var sound1 = new Audio("./assets/higher_left.wav");
  },
  //追加//追加//追加//追加//追加
  data() {
    return {
      songs: [
        {
          num: 1,
          src: require(".././assets/puzzle/puzzle5/puzzle5_1.mp3"),
        },
        {
          num: 2,
          src: require(".././assets/puzzle/puzzle5/puzzle5_2.mp3"),
        },
        {
          num: 3,
          src: require(".././assets/puzzle/puzzle5/puzzle5_3.mp3"),
        },
        {
          num: 4,
          src: require(".././assets/puzzle/puzzle5/puzzle5_4.mp3"),
        },
        {
          num: 5,
          src: require(".././assets/puzzle/puzzle5/puzzle5_5.mp3"),
        },
        {
          num: 6,
          src: require(".././assets/puzzle/puzzle5/puzzle5_6.mp3"),
        },
        {
          num: 7,
          src: require(".././assets/puzzle/puzzle5/puzzle5_7.mp3"),
        },
        {
          num: 8,
          src: require(".././assets/puzzle/puzzle5/puzzle5_8.mp3"),
        },
         {
          num: 9,
          src: require(".././assets/puzzle/puzzle5/puzzle5_9.mp3"),
        },
        {
            num: 10,
            src: require(".././assets/puzzle/puzzle5/puzzle5.mp3"),
        },
      ],
      board0: {src: "puzzle5_b1.png"},
      board1: {src: "puzzle5_b2.png"},
      board2: {src: "puzzle5_b3.png"},
      board3: {src: "puzzle5_b4.png"},
      board4: {src: "puzzle5_b5.png"},
      board5: {src: "puzzle5_b6.png"},
      board6: {src: "puzzle5_b7.png"},
      board7: {src: "puzzle5_b8.png"},
      board8: {src: "puzzle5_b9.png"},
      player: new Audio(),
      isPlaying: false,
      num: 0,
      style1: {
        margin: "0 auto",
        "backgroundImage": "url(" + require(".././assets/speaker_logo.png") + ")",
        "background-size": "cover",
      },
      which:true,
      check:0,
       c: [
        {
          id: "card_1",
          num: 0
        },
        {
          id: "card_2",
          num: 1
        },
        {
          id: "card_3",
          num: 2
        },
        {
          id: "card_4",
          num: 3
        },
        {
          id: "card_5",
          num: 4
        },
        {
          id: "card_6",
          num: 5
        },
        {
          id: "card_7",
          num: 6
        },
        {
          id: "card_8",
          num: 7
        },
        {
          id: "card_9",
          num: 8
        },
      ],
      x: [0,1,2,3,4,5,6,7,8],
      i:0,
      l:0,
    };
  },
  methods: {
    shuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let r = Math.floor(Math.random() * (i + 1))
        let tmp = array[i]
        array[i] = array[r]
        array[r] = tmp
      }
      console.log(array)
      return array
    },
    play_sound1: function(song) {
      this.current = this.songs[this.num - 1];
      this.player.src = this.current.src;

      if (typeof song.src != "undefined") {
        this.current = song;
        this.player.src = this.current.src;
      }
      var isPlaying = !this.isPlaying;
      if (isPlaying) {
        console.log("play");
        //sound1.play();
        this.player.play();
        // which = 0;
        this.isPlaying = !this.isPlaying;
      } else {
        this.player.pause();
        console.log("stop");
        // which = 1;
        this.isPlaying = !this.isPlaying;
      }
    },
    play_sound: function(num) {
      this.num = num;
      this.play_sound1(this.songs);
    },
    //モーダルウィンドウの追加
    //モーダルウィンドウの追加
    openModal(){
      // this.$refs.modal.show();
      const modal = document.getElementById("modal_explain");
      modal.classList.add("show");
    },
    closeModal(){
      // this.$refs.modal.show();
      const modal = document.getElementById("modal_explain");
      modal.classList.remove("show");
    },
    reset() {
      this.$router.go({path: this.$router.currentRoute.path, force: true});
    }
  },
  computed:{
    //try//try//try//try//try//try//try//try//try//try
    card_result_1:function(){
      if (this.$store.state.much_card[this.c[this.x[0]].num].status == 1) {
        return {
          //backgroundColor: "green", 
          display:"none",
          };
      }
      else{
        return {
          backgroundColor: "white", 
          };
      }
    },
    card_result_2:function(){
      if (this.$store.state.much_card[this.c[this.x[1]].num].status == 1) {
        return {
          //backgroundColor: "green", 
          display:"none",
          };
      }
      else{
        return {
          backgroundColor: "white", 
          };
      }
    },
    card_result_3:function(){
      if (this.$store.state.much_card[this.c[this.x[2]].num].status == 1) {
        return {
          //backgroundColor: "green", 
          display:"none",
          };
      }
      else{
        return {
          backgroundColor: "white", 
          };
      }
    },
    card_result_4:function(){
      if (this.$store.state.much_card[this.c[this.x[3]].num].status == 1) {
        return {
          //backgroundColor: "green", 
          display:"none",
          };
      }
      else{
        return {
          backgroundColor: "white", 
          };
      }
    },
    card_result_5:function(){
      if (this.$store.state.much_card[this.c[this.x[4]].num].status == 1) {
        return {
          //backgroundColor: "green", 
          display:"none",
          };
      }
      else{
        return {
          backgroundColor: "white", 
          };
      }
    },
    card_result_6:function(){
      if (this.$store.state.much_card[this.c[this.x[5]].num].status == 1) {
        return {
          //backgroundColor: "green", 
          display:"none",
          };
      }
      else{
        return {
          backgroundColor: "white", 
          };
      }
    },
    card_result_7:function(){
      if (this.$store.state.much_card[this.c[this.x[6]].num].status == 1) {
        return {
          //backgroundColor: "green", 
          display:"none",
          };
      }
      else{
        return {
          backgroundColor: "white", 
          };
      }
    },
    card_result_8:function(){
      if (this.$store.state.much_card[this.c[this.x[7]].num].status == 1) {
        return {
          //backgroundColor: "green", 
          display:"none",
          };
      }
      else{
        return {
          backgroundColor: "white", 
          };
      }
    },
    card_result_9:function(){
      if (this.$store.state.much_card[this.c[this.x[8]].num].status == 1) {
        return {
          //backgroundColor: "green", 
          display:"none",
          };
      }
      else{
        return {
          backgroundColor: "white", 
          };
      }
    },
    last_result:function(){
      if(this.$store.state.much_card[0].status==1 && 
      this.$store.state.much_card[1].status==1 &&
      this.$store.state.much_card[2].status==1 &&
      this.$store.state.much_card[3].status==1 &&
      this.$store.state.much_card[4].status==1 &&
      this.$store.state.much_card[5].status==1 &&
      this.$store.state.much_card[6].status==1 &&
      this.$store.state.much_card[7].status==1 &&
      this.$store.state.much_card[8].status==1
      ){
        localStorage.check5 = 1;
        const modal = document.getElementById("modal_done");
        modal.classList.add("show");
        this.playsound(10);
        return ""
      }
      else{
        return ""
      }
    },
    //try//try//try//try//try//try//try//try//try//try


  },
  //作られた時に実行される
  created() {
    this.current = this.songs[this.num];
    this.player.src = this.current.src;
    if(window.name != "reseted") {
      this.$router.go({path: this.$router.currentRoute.path, force: true});
      window.name = "reseted";
    } else {
      window.name = "";
    }
    this.shuffle(this.x);
  },
};
</script>

<style>
@import ".././css/global.css";
</style>

<style scoped>
@import ".././css/style_4.css";
.sample5{
    width:350px;
    height:197px;
    background-image: url(".././assets/puzzle/puzzle5/puzzle5.jpg");
    background-size: cover;
}
</style>
